import React from 'react';

import { EmployerSettingsForm } from 'src/components/account/EmployerSettingsForm/EmployerSettingsForm';
import { PeoPayrollProviderSettingsForm } from 'src/components/account/PeoPayrollProviderSettingsForm/PeoPayrollProviderSettingsForm';
import { PeoSettingsForm } from 'src/components/account/PeoSettingsForm/PeoSettingsForm';
import { DetailPageLayout } from 'src/components/common';
import { useCurrentUserPeo } from 'src/hooks/peo';
import { useCurrentUserPeoPayrollProvider } from 'src/hooks/peoPayrollProvider';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const SettingsPage: React.FC = () => {
  const { isPeoSuperAdmin, isPeoAdmin, isPeoPayrollProviderUser } = useCurrentUserPermissions();
  const { peo, updatePeoWithEmployers } = useCurrentUserPeo();
  const { peoPayrollProvider, updatePeoPayrollProvider } = useCurrentUserPeoPayrollProvider();

  const renderSettingForm = React.useCallback(() => {
    if ((isPeoSuperAdmin || isPeoAdmin) && peo) {
      return <PeoSettingsForm peo={peo} updatePeoWithEmployers={updatePeoWithEmployers} />;
    }
    if (isPeoPayrollProviderUser && peoPayrollProvider) {
      return (
        <PeoPayrollProviderSettingsForm
          peoPayrollProvider={peoPayrollProvider}
          updatePeoPayrollProvider={updatePeoPayrollProvider}
        />
      );
    }

    return <EmployerSettingsForm />;
  }, [
    isPeoSuperAdmin,
    isPeoAdmin,
    peo,
    isPeoPayrollProviderUser,
    peoPayrollProvider,
    updatePeoWithEmployers,
    updatePeoPayrollProvider,
  ]);

  return <DetailPageLayout titleContent="Settings">{renderSettingForm()}</DetailPageLayout>;
};
